import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
interface CtaButtonProps {
  text?: string;
  className?: string;
}
const CHECKOUT_URL = 'https://templeofpages.com/cart/49069769523443:1?locale=es';
export function CtaButton({
  text = 'SÍ, QUIERO RECUPERAR MI POTENCIA AHORA',
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    trackAddToCart();
    // Small delay so the pixel beacon has time to fire before navigation
    window.setTimeout(() => {
      window.location.href = CHECKOUT_URL;
    }, 150);
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`relative group w-full sm:w-auto ${className}`} data-id="element-19">
      <motion.div animate={{
      opacity: [0.35, 0.6, 0.35],
      scale: [1, 1.02, 1]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -inset-1 bg-brand-gold rounded-lg blur group-hover:opacity-75 transition duration-500 group-hover:duration-200" data-id="element-20"></motion.div>
      <div className="relative flex items-center justify-center w-full px-8 py-5 bg-brand-gold hover:bg-brand-goldHover text-brand-darker font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_20px_rgba(212,162,76,0.3)] transition-all uppercase tracking-wide overflow-hidden" data-id="element-21">
        <motion.div aria-hidden="true" className="pointer-events-none absolute inset-y-0 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/45 to-transparent" initial={{
        left: '-40%'
      }} animate={{
        left: ['-40%', '120%']
      }} transition={{
        duration: 1.2,
        repeat: Infinity,
        repeatDelay: 1.8,
        ease: 'easeInOut'
      }} data-id="element-22" />
        <Zap className="w-6 h-6 mr-3 fill-brand-darker relative z-10" data-id="element-23" />
        <span className="relative z-10" data-id="element-24">{text}</span>
      </div>
    </motion.button>;
}